var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    [
      _vm.$store.state.TravelService.editedTravelServiceItem !== null
        ? [
            _vm.$store.state.TravelService.editedTravelServiceItem.type ===
            "hotel"
              ? _c("order-service-hotel-dialog")
              : _vm._e(),
            _vm.$store.state.TravelService.editedTravelServiceItem.type ===
            "car"
              ? _c("order-service-car")
              : _vm._e(),
            _vm.$store.state.TravelService.editedTravelServiceItem.type ===
            "rail"
              ? _c("order-service-rail")
              : _vm._e(),
            _vm.$store.state.TravelService.editedTravelServiceItem.type ===
            "flight"
              ? _c("order-service-flight")
              : _vm._e(),
            _vm.$store.state.TravelService.editedTravelServiceItem.type ===
            "other"
              ? _c("order-service-other")
              : _vm._e(),
            _vm.$store.state.TravelService.editedTravelServiceItem.type ===
            "insurance"
              ? _c("order-service-insurance-dialog")
              : _vm._e()
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }